import { inject } from 'vue';
import { useQuery, useInfiniteQuery } from '@tanstack/vue-query';
import axios from 'axios';

const defaultApiUrl = '/api/reputation/';

const fetchReputationSummaryData = (apiUrl, locationId) =>
  axios({
    url: `${apiUrl}summary`,
    params: { locationIDs: locationId, groupBy: 'Source' },
  }).then((res) => res.data);

export const useReputationSummaryQuery = (locationId) => {
  const jssStore = inject('jssStore');
  const apiUrl =
    jssStore?.sitecoreContext()?.['Feature.Venues.ReputationProxyApiUrl'] || defaultApiUrl;

  return useQuery(
    ['reputation-summary', locationId],
    () => fetchReputationSummaryData(apiUrl, locationId),
    {
      retry: 3,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      staleTime: 1000 * 60 * 60 * 24,
    }
  );
};

export const fetchReputationReviewsResponseData = (reviewId) => {
  const jssStore = inject('jssStore');
  const apiUrl =
    jssStore?.sitecoreContext()?.['Feature.Venues.ReputationProxyApiUrl'] || defaultApiUrl;
  return axios(`${apiUrl}reviews/${reviewId}/responses`).then((res) => res.data);
};

const fetchReputationReviewsData = async (
  apiUrl,
  venueId,
  sourceID,
  limit,
  from,
  to,
  offset = 0
) => {
  const queryParams = {
    locationID: venueId,
    sourceID,
    limit,
    offset,
  };

  if (from || to) {
    queryParams.from = from;
    queryParams.to = to;
  } else {
    queryParams.range = 'LifeToDate';
  }

  return await axios
    .get(`${apiUrl}reviews`, {
      params: queryParams,
    })
    .then((res) => res.data);
};

export const useReputationReviewsQuery = ({
  venueId,
  sourceID,
  limit = 5,
  offset = { value: 0 },
  from = null,
  to = null,
}) => {
  const jssStore = inject('jssStore');
  const apiUrl =
    jssStore?.sitecoreContext()?.['Feature.Venues.ReputationProxyApiUrl'] || defaultApiUrl;

  return useInfiniteQuery(
    ['reputation-reviews', venueId, sourceID, from, to, limit],
    () => fetchReputationReviewsData(apiUrl, venueId, sourceID, limit, from, to, offset.value),
    {
      retry: 3,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      staleTime: 1000 * 60 * 60 * 24,
      getNextPageParam: () => null,
    }
  );
};
